import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { APISERVICE } from 'services/api.service'
import { toast } from 'react-toastify'

// Valores iniciales del formulario.
const initialValues = { currentPassword: '', newPassword: '', repeatPassword: '' }

/**
 * Componente, Formulario de cambio de contraseña de usuario.
 * @returns {JSX.Element} Retorna el componente FormChangePassword.
 */
function FormChangePassword() {
    const [submitting, setSubmitting] = useState(false)
    const [values, setValues] = useState(initialValues)
    const [errors, setErrors] = useState({})

    const handleChange = (e) => {
        const name = e.target.name
        setValues({ ...values, [name]: e.target.value })
        errors[name] && setErrors({ ...errors, [name]: '' })
    }

    const validate = () => {
        const _errors = {}
        if (!values.currentPassword) _errors.currentPassword = 'Requerido'
        if (!values.newPassword) _errors.newPassword = 'Requerido'
        if (!values.repeatPassword) _errors.repeatPassword = 'Requerido'
        if (values.newPassword && values.repeatPassword) {
            if (values.newPassword !== values.repeatPassword) _errors.repeatPassword = 'Las contraseñas deben coincidir'
        }
        setErrors(_errors)
        return Object.keys(_errors).length === 0
    }

    const changePassword = async () => {
        setSubmitting(true)
        if (validate()) {
            const response = await APISERVICE.post('usuario/change-password', '', values)
            if (response.status === 200) {
                toast.success(response.message)
                setValues(initialValues)
            } else if (response.status === 400) {
                setErrors({...errors, currentPassword: 'Contraseña incorrecta'})
            } else {
                toast.error('Ocurrió un error al realizar la operación')
            }
        }
        setSubmitting(false)
    }

    return (
        <div>
            <div className='mb-4'>
                <label className='form-label'>Contraseña actual</label>
                <Form.Control
                    type='password'
                    name='currentPassword'
                    value={values.currentPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.currentPassword}
                />
                {errors.currentPassword && <div className='invalid-feedback'>{errors.currentPassword}</div>}
            </div>
            <div className='mb-3'>
                <label className='form-label'>Contraseña nueva</label>
                <Form.Control
                    type='password'
                    name='newPassword'
                    value={values.newPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.newPassword}
                />
                {errors.newPassword && <div className='invalid-feedback'>{errors.newPassword}</div>}
            </div>
            <div className='mb-3'>
                <label className='form-label'>Repetir nueva contraseña</label>
                <Form.Control
                    type='password'
                    name='repeatPassword'
                    value={values.repeatPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.repeatPassword}
                />
                {errors.repeatPassword && <div className='invalid-feedback'>{errors.repeatPassword}</div>}
            </div>
            <div className='text-center'>
                <Button type='submit' variant='blue' disabled={submitting} onClick={changePassword}>
                    Guardar
                </Button>
            </div>
        </div>
    )
}
export default FormChangePassword
